import { useInvalidate, useLogout } from "@refinedev/core";
import { ConfigProvider, Modal, Row } from "antd";
import StagingAuthContext from "context/StagingAuthContext";
import { useContext, useState } from "react";
import classes from "./Logout.module.css";

export const Logout = ({ close, open }: { close: () => void; open: boolean }) => {
  const [loading, setLoading] = useState(false);
  const { mutate: handleLogout } = useLogout();
  const { setIsLoggedIn } = useContext(StagingAuthContext);
  const invalidate = useInvalidate();

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgBase: "#202440"
        },
        components: {
          Modal: {
            contentBg: "#202440",
            colorText: "#fff"
          }
        }
      }}>
      <Modal
        open={open}
        onCancel={close}
        closable={false}
        maskClosable={!loading}
        width={300}
        okText="Yes"
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "none",
          },
          disabled: loading,
        }}
        okButtonProps={{
          disabled: loading,
          loading: loading
        }}
        onOk={() => {
          setLoading(true);
          setIsLoggedIn(false);
          handleLogout({
            redirectPath: "/login",
          });
          invalidate({
            invalidates: [
              "all"
            ]
          });
        }}
        styles={{
          footer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          content: {
            padding: "12px"
          }
        }}>
        <Row className={classes.logoutTitle} justify="center">
          Logout
        </Row>
        <Row className={classes.subTitle} justify="center">
          Are you sure you want to logout?
        </Row>
      </Modal>
    </ConfigProvider>
  );
};
